import ApplianceModelService from "../ApplianceModelService"
import ApplianceModelTypeEntity from "../../ModelType/Entity/ApplianceModelTypeEntity"

const
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    CLEAR_RECORD = "CLEAR_RECORD",
    CLEAR_RECORDS = "CLEAR_RECORDS"

const initialState = {
    isLoading: false,
    records: [],
    totalRecords: 0,
    error: null,
}

export const state = {...initialState}

export const actions = {

    /**
     * @param commit
     * @param id : Number
     * @returns {Promise<[]>}
     */
    async getModelTypes({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await ApplianceModelService.getModelTypes(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    async clear({commit}) {
        commit(CLEAR_RECORD)
    },

    async clearAll({commit}) {
        commit(CLEAR_RECORDS)
    },

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.error = null
        state.records = []
        state.totalRecords = 0
    },
    [FETCHING_RECORDS_SUCCESS](state, data) {
        state.isLoading = false
        state.records = data.map((record) => ApplianceModelTypeEntity.from(record))
        state.totalRecords = data.length
    },
    [FETCHING_RECORDS_ERROR](state, error) {
        state.isLoading = false
        state.error = error
        state.records = []
        state.totalRecords = 0
    },

    [CLEAR_RECORD](state) {
        state.isLoading = false
        state.error = null
        state.record = null
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.error = null
        state.records = []
        state.totalRecords = 0
    },

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },

    hasError(state) {
        return state.error !== null
    },

    error(state) {
        return state.error
    },

    hasModelTypes(state) {
        return state.records.length > 0
    },

    getModelTypes(state) {
        return state.records
    },

    getTotalModelTypes(state) {
        return state.totalRecords
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
